"use strict";
/** @module BryxApi.SupportApi */
Object.defineProperty(exports, "__esModule", { value: true });
var models_1 = require("../../models");
var DeviceMixin = /** @class */ (function () {
    function DeviceMixin() {
    }
    DeviceMixin.prototype.getDevicePushes = function (clientId, deviceId, callback) {
        var _this = this;
        var wrappedCallback = function (request, response) {
            callback(_this.apiArrayResultFromParse(response, models_1.PushNotification.parse, 'warn'));
        };
        this.http.get("/clients/" + clientId + "/devices/" + deviceId + "/pushes", null, this.unauthenticatedCallback(wrappedCallback));
    };
    DeviceMixin.prototype.removeClientDevice = function (clientId, deviceId, callback) {
        var _this = this;
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, _this.nullParser));
        };
        this.http.del("/clients/" + clientId + "/devices/" + deviceId, null, this.unauthenticatedCallback(wrappedCallback));
    };
    DeviceMixin.prototype.sendTestPush = function (clientId, deviceId, alert, callback) {
        var _this = this;
        var body = { alert: alert };
        var wrappedCallback = function (request, response) {
            callback(_this.apiResultFromParse(response, _this.nullParser));
        };
        this.http.post("/clients/" + clientId + "/devices/" + deviceId + "/testpush", null, body, this.unauthenticatedCallback(wrappedCallback));
    };
    return DeviceMixin;
}());
exports.default = DeviceMixin;
//# sourceMappingURL=DeviceMixin.js.map